/**
 * 一般条件
 */
export const GENERAL_CONDITION = 'general'

/**
 * 其他条件
 */
export const OTHER_CONDITION = 'other_condition'
